import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { RegistrationService } from 'src/app/private/services/registration.service';
import { UploadService } from 'src/app/private/services/upload.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-upload-documents',
  standalone: true,
  imports: [SharedModule, FileUploadModule],
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.scss']
})
export class UploadDocumentsComponent {
  @Input() editLeadData: any = {};
  @Output() closeDialog = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  documents = [
    { label: 'Birth Certificate', value: 'Birth Certificate' },
    { label: 'Aadhaar Card', value: 'Aadhaar Card' },
    { label: 'PAN Card', value: 'PAN Card' },
    { label: 'Passport', value: 'Passport' },
    { label: 'Ration Card', value: 'Ration Card' },
    { label: 'Voter ID', value: 'Voter ID' },
    { label: 'Electricity Bill', value: 'Electricity Bill' },
    { label: 'Water Bill', value: 'Water Bill' },
    { label: 'Telephone Bill', value: 'Telephone Bill' },
    { label: 'Driving License', value: 'Driving License' },
    { label: 'Previous School Transfer Certificate', value: 'Previous School Transfer Certificate' },
    { label: 'Mark Sheets', value: 'Mark Sheets' },
    { label: 'Character Certificate', value: 'Character Certificate' },
    { label: 'Migration Certificate', value: 'Migration Certificate' },
    { label: 'Caste Certificate', value: 'Caste Certificate' },
    { label: 'Income Certificate', value: 'Income Certificate' },
    { label: 'EWS Certificate', value: 'EWS Certificate' },
    { label: 'Medical Fitness Certificate', value: 'Medical Fitness Certificate' },
    { label: 'Vaccination Records', value: 'Vaccination Records' },
    { label: 'Disability Certificate', value: 'Disability Certificate' },
    { label: 'Aadhaar Card of Parents/Guardian', value: 'Aadhaar Card of Parents/Guardian' },
    { label: 'Income Proof', value: 'Income Proof' },
    { label: 'Employment Proof', value: 'Employment Proof' },
    { label: 'Affidavit', value: 'Affidavit' },
    { label: 'Passport-size Photographs', value: 'Passport-size Photographs' },
    { label: 'Domicile Certificate', value: 'Domicile Certificate' },
    { label: 'Bonafide Certificate', value: 'Bonafide Certificate' }
  ];
  
  isLoading = false;
  selectedCategory: any;
  uploadedFiles: any[] = [];
  isUploading = false; // Flag to track if files are being uploaded

  constructor(
    private uploadService: UploadService,
    private registrationService: RegistrationService,
    private localStorageService: LocalStorageService,
    private messageService: MessageService
  ) {}

  async onFileSelect(event: any) {
    this.isUploading = true; // Start upload process
    console.log('Files selected:', event);
    const uploadPromises = event.currentFiles.map((file: File) => this.uploadFile(file));

    await Promise.all(uploadPromises);
    this.isUploading = false; // Upload process completed
    this.fileUpload.clear();
  }

  async uploadFile(file: File) {
    const fileType = this.getFileType(file.name);
    try {
      const uploadUrl = await this.uploadToS3(file);
      if (uploadUrl) {
        this.uploadedFiles.push({
          document_url: uploadUrl.split('?')[0], // Store only the S3 file URL
          lead_id: this.editLeadData.lead_id,
          reg_id: this.editLeadData.registration?.reg_id,
          organization_id: this.localStorageService.getOrganizationId(),
          document_category: this.selectedCategory,
          document_type: fileType,
          document_name: file.name,
          upload_status: 'Uploaded'
        });
      }
    } catch (error) {
      console.error('File upload failed:', error);
    }
  }

  getFileType(filename: string): string {
    const ext = filename.split('.').pop()?.toLowerCase();
    return ['png', 'jpg', 'jpeg'].includes(ext!) ? 'image' : ext === 'pdf' ? 'pdf' : 'unknown';
  }

  async uploadToS3(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      const folder = `education/students/documents`;
      formData.append('file', file);
      formData.append('folders', folder);
      formData.append('bucket', 'global-upload-storage');

      this.uploadService.uploadDocuments(formData).subscribe({
        next: (response: any) => {
          console.log('File uploaded successfully:', response);
          resolve(response.url); // Assuming API returns { url: 's3-url' }
        },
        error: (error) => {
          console.error('Error uploading file:', error);
          reject('');
        },
      });
    });
  }

  removeFile(index: number) {
    this.uploadedFiles.splice(index, 1);
  }

  submitFiles() {
    if (this.isUploading) {
      console.warn('Files are still uploading. Please wait.');
      this.messageService.add({ severity: 'warn', summary: 'Please wait', detail: 'Files are still uploading. Please wait.' });
      return;
    }
    console.log('Submitting files:', this.uploadedFiles);
    // Call API to save uploaded files if required
    this.isLoading = true;
    this.registrationService.createDocument(this.uploadedFiles).subscribe({
      next: (response) => {
        this.isLoading = false;
        console.log('Documents uploaded successfully:', response);
        this.messageService.add({ severity: 'success', summary: 'Documents uploaded successfully', detail: 'Documents uploaded successfully' });
        this.closeDialog.emit();
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error uploading documents:', error);
        this.messageService.add({ severity: 'error', summary: 'Error uploading documents', detail: 'Error uploading documents' });
      }
    });

  }

  handleCloseDialog() {
    this.closeDialog.emit();
  }
}
